/* ET - Campaign card badge: keeps the campaign badge on a product card in step with the colour picked on the card, the
   same way assets/product-card-variant-price.js updates the price, so a colour with its own discount (a Limited Edition
   at 15%) never shows the percentage of the first colour. data-et-sale-variants holds the on-sale variants as
   "id:percent" (snippets/et-campaign-card-badge.liquid). */
(function () {
  if (window.etCampaignCardBadges) return;
  window.etCampaignCardBadges = true;

  function salePercent(badge, variantId) {
    var entries = (badge.getAttribute('data-et-sale-variants') || '').split(',');
    for (var i = 0; i < entries.length; i++) {
      var parts = entries[i].split(':');
      if (parts[0] === String(variantId)) return parts[1] || '';
    }
    return null;
  }

  document.addEventListener('change', function (event) {
    var radio = event.target;
    if (!radio.matches || !radio.matches('.product-card__swatch-list [type="radio"], .product-card__variant-list [type="radio"]')) return;

    var card = radio.closest('product-card');
    var badge = card && card.querySelector('.et-campaign-badge[data-et-label]');
    var variantId = radio.getAttribute('data-variant-id');
    if (!badge || !variantId) return;

    var percent = salePercent(badge, variantId);
    badge.hidden = percent === null;
    if (percent !== null) badge.textContent = badge.getAttribute('data-et-label').split('[percent]').join(percent);
  });
})();
